import React from 'react';
import DocumentTitle from 'react-document-title';

import Link from 'ui/Link';
import { HOME_SCREEN } from 'routes';

import 'css/ui/screens/NotFoundScreen.css';


class NotFoundScreen extends React.Component {

	render() {
		return (
			<div className="not-found-screen">
				<DocumentTitle title="404 - Caleb Miller" />
				<h1>
					<span>4</span>
					<span>0</span>
					<span>4</span>
				</h1>

				<p>That page does not exist!<br />It's probably my fault.</p>
				<p><Link to={HOME_SCREEN} light>Go to home page</Link></p>
			</div>
		);
	}
}

export default NotFoundScreen;



// WEBPACK FOOTER //
// ./src/ui/screens/NotFoundScreen.jsx